module.exports = "\r\n.material-icons{\r\n    background-color: white;\r\n    border:none;\r\n}"